import { ReimbursableTaxonomiesMappingForm } from 'modules/attendance/lib/forms/utils/CustomTimeRangesFormData'

const removeMapping = (
  currentMappings: ReimbursableTaxonomiesMappingForm[],
  newMapping: ReimbursableTaxonomiesMappingForm
) => {
  return currentMappings.filter((item) => item.legalEntityId !== newMapping.legalEntityId)
}

const upsertMapping = (
  formMappings: ReimbursableTaxonomiesMappingForm[],
  newMapping: ReimbursableTaxonomiesMappingForm
) => {
  const updatedMappings = formMappings.map((formMapping) =>
    formMapping.legalEntityId === newMapping.legalEntityId ? newMapping : formMapping
  )

  // If there's already a mapping in the form for the same legalEntityId, we're updating it, otherwise we're adding it
  if (!updatedMappings.includes(newMapping)) {
    updatedMappings.push(newMapping)
  }

  return updatedMappings
}

export const manageMapping = ({
  taxonomyId,
  mappingId,
  timeRangeCategoryId,
  legalEntityId,
  formMappings,
}: {
  taxonomyId: string
  mappingId?: string
  timeRangeCategoryId?: number
  legalEntityId: number
  formMappings: ReimbursableTaxonomiesMappingForm[]
}) => {
  const reimbusableTaxonomyMapping = {
    id: mappingId,
    supplementTaxonomyId: taxonomyId,
    legalEntityId: legalEntityId.toString(),
    timeRangeCategoryId: timeRangeCategoryId?.toString() || '0',
  }

  // If supplementTaxonomyId doesn't exist, means that the none option was selected, hence we're removing the mapping
  if (reimbusableTaxonomyMapping.supplementTaxonomyId.length == 0) {
    return removeMapping(formMappings, reimbusableTaxonomyMapping)
  }

  return upsertMapping(formMappings, reimbusableTaxonomyMapping)
}
